import React, { useCallback } from "react";

import { graphql, useFragment } from "react-relay";
import { TVDashboardPickerPopover } from "./TVDashboardPickerPopover";
import { PopoverButton } from "./PopoverButton";
import { TVDashboardPickerButton_dashboards$key } from "./__generated__/TVDashboardPickerButton_dashboards.graphql";
import { TVDashboardPickerButton_dashboard$key } from "./__generated__/TVDashboardPickerButton_dashboard.graphql";

export function StorecastPickerButton(props: {
  currentDashboard: TVDashboardPickerButton_dashboard$key;
  dashboards: TVDashboardPickerButton_dashboards$key;
  onChangeDashboard?: (dashboard: { id: string }) => void;
  isCompact: boolean;
  children: (open: () => void) => React.ReactNode;
}) {
  const dashboard = useFragment(
    graphql`
      fragment TVDashboardPickerButton_dashboard on Dashboard {
        id
        name
      }
    `,
    props.currentDashboard
  );

  const dashboards = useFragment(
    graphql`
      fragment TVDashboardPickerButton_dashboards on Dashboard
      @relay(plural: true) {
        id
        ...TVDashboardPickerPopoverDashboards
      }
    `,
    props.dashboards
  );

  const popoverContent = useCallback(
    (close: () => void) =>
      props.onChangeDashboard ? (
        <TVDashboardPickerPopover
          currentDashboardId={dashboard.id}
          onClose={close}
          onSelectItem={props.onChangeDashboard}
          dashboards={dashboards}
        />
      ) : null,
    [dashboard.id, dashboards, props.onChangeDashboard]
  );

  return (
    <PopoverButton popoverContent={popoverContent}>
      {props.children}
    </PopoverButton>
  );
}
